import { Container, FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { AppDispatch, RootState } from '../../store/store';
import { fetchDoctorsByHospital } from '../../store/usersSlice';
import InfoBox from '../ui/DaliaComponents';
import WizardStep from '../ui/WizardStep';
import './PatientInitWizardStep.css';

const PatientInitStepDoctorSelect: WizardStep = ({ formik }) => {
  const dispatch: AppDispatch = useDispatch();
  const { profile } = useSelector((state: RootState) => state.auth);
  const { doctors } = useSelector((state: RootState) => state.users);

  useEffect(() => {
    if (profile?.hospital?.id) {
      void dispatch(fetchDoctorsByHospital(profile.hospital.id));
    }
  }, [dispatch, profile?.hospital?.id]);

  return (
    <Container className="mt-5 container-wizard">
      <Grid container spacing={2}>
        <Grid size={12}>
          <InfoBox emoji="👨‍⚕️">Veuillez sélectionner le médecin qui suivra ce patient</InfoBox>
        </Grid>

        <Grid size={12}>
          <FormControl error={!!(formik.touched.doctorId && formik.errors.doctorId)} fullWidth>
            <InputLabel id="doctor-select-label">Médecin</InputLabel>
            <Select
              id="doctorId"
              label="Médecin"
              labelId="doctor-select-label"
              name="doctorId"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.doctorId || ''}
            >
              {doctors.map((doctor) => (
                <MenuItem key={doctor.id} value={doctor.id}>
                  {doctor.firstName} {doctor.lastName} ({doctor.email})
                </MenuItem>
              ))}
            </Select>
            {formik.touched.doctorId && formik.errors.doctorId && <FormHelperText>{formik.errors.doctorId}</FormHelperText>}
          </FormControl>
        </Grid>
      </Grid>
    </Container>
  );
};

PatientInitStepDoctorSelect.label = 'Sélection du médecin';

PatientInitStepDoctorSelect.initialValues = {
  doctorId: '',
};

PatientInitStepDoctorSelect.validationSchema = () => {
  return Yup.object({
    doctorId: Yup.string().required('Veuillez sélectionner un médecin'),
  });
};

export default PatientInitStepDoctorSelect;
